import { isEmpty } from 'lodash';
import { useState } from 'react';
import { batch } from 'react-redux';

import { BudgetBakersResponse } from '@skippay/core/@types/budgetBakers';
import { Maybe } from '@skippay/core/utils/types';

type ActiveModal = 'error' | 'chooseBank' | 'loading' | 'complete';

type BudgetBakersStates = {
	budgetBakersChooseBankModalOpen: boolean;
	activeModal: ActiveModal | undefined;
	isBudgetBakersStarted: boolean;
	isBudgetBakersCancelled: boolean;
	selectedBank: string | undefined;
	selectedBankAccount: string | undefined;
	setBudgetBakersChooseBankModalOpen: (value: boolean) => void;
	setIsBudgetBakersStarted: (value: boolean) => void;
	setSelectedBank: (value: string | undefined) => void;
	setIsBudgetBakersCancelled: (value: boolean) => void;
	resetView: () => void;
	closeModal: () => void;
	setActiveModal: (value: ActiveModal | undefined) => void;
	setSelectedBankAccount: (value: string | undefined) => void;
	backStatus: {
		canGoBack: boolean;
		handleGoBack: () => void;
	};
};

function useConfirmationIncomeStates(
	budgetBakers: Maybe<BudgetBakersResponse>
): BudgetBakersStates {
	const [budgetBakersChooseBankModalOpen, setBudgetBakersChooseBankModalOpen] =
		useState<boolean>(false);
	const [isBudgetBakersCancelled, setIsBudgetBakersCancelled] = useState<boolean>(false);
	const [isBudgetBakersStarted, setIsBudgetBakersStarted] = useState<boolean>(false);
	const [activeModal, setActiveModal] = useState<ActiveModal | undefined>(undefined);
	const [selectedBank, setSelectedBank] = useState<string | undefined>(undefined);
	const [selectedBankAccount, setSelectedBankAccount] = useState<string | undefined>(undefined);

	const resetView = () => {
		batch(() => {
			setIsBudgetBakersCancelled(false);
			setIsBudgetBakersStarted(false);
			setSelectedBank(undefined);
			setSelectedBankAccount(undefined);
		});
	};

	const closeModal = () => {
		setActiveModal(undefined);
	};

	return {
		budgetBakersChooseBankModalOpen,
		activeModal,
		isBudgetBakersStarted,
		isBudgetBakersCancelled,
		selectedBank,
		selectedBankAccount,
		setBudgetBakersChooseBankModalOpen,
		setIsBudgetBakersStarted,
		setSelectedBank,
		setIsBudgetBakersCancelled,
		resetView,
		closeModal,
		setActiveModal,
		setSelectedBankAccount,
		backStatus: {
			canGoBack: !!(
				(isBudgetBakersStarted && selectedBank) ||
				(isBudgetBakersStarted && !isEmpty(budgetBakers?.bankAccounts))
			),
			handleGoBack: resetView,
		},
	};
}

export default useConfirmationIncomeStates;
